import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@services/translate/translate.service';

@Component({
    selector: 'password-confirm',
    templateUrl: './password-confirm.component.html',
    styleUrls: ['./password-confirm.component.scss'],
    standalone: false
})
export class PasswordConfirmComponent implements OnInit {

  @Output() validation = new EventEmitter<string>();

  validated = false;
  password: string;
  passwordConfirm: string;

  messages: any;
  hints: { password: any, passwordConfirm: any };
  isLoading = false;
  isPasswordVisible = false;

  constructor(private ts: TranslateService) {
    this.isLoading = true;
    const messages = this.ts.get('login');
    if (messages) {
      this.messages = messages;
      this.hints = {
        password: { message: this.messages.password.hints.defaultMessage, level: 'info' },
        passwordConfirm: { message: this.messages.password.hints.notCorresponding, level: 'warn' }
      };
      this.isLoading = false;
    }
  }

  ngOnInit() {

  }

  validate() {
    this.validated = this.password.length >= 8;

    if (!this.validated) {
      this.hints.password = { message: this.messages.password.hints.minLength, level: 'warn' };
    } else {
      this.hints.password = { message: this.messages.password.hints.valid, level: 'confirmed' };
    }
    if (this.validated && this.password === this.passwordConfirm) {
      this.validation.emit(this.password);
    } else {
      this.validation.emit(null);
    }
    return this.validated;
  }

}
